/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxFrontOpenIcon24Solid = forwardRef('DeliveryBoxFrontOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m.109 9.053 1.452-4.65A2 2 0 0 1 3.471 3H14l-1.621 6.485A2 2 0 0 1 10.439 11H1.54A1.5 1.5 0 0 1 .11 9.053Z" }),
        React.createElement("path", { d: "m14 3 1.621 6.485A2 2 0 0 0 17.561 11h4.899a1.5 1.5 0 0 0 1.431-1.947l-1.452-4.65A2 2 0 0 0 20.529 3H14Z" }),
        React.createElement("path", { d: "M13.25 10.75A2 2 0 0 1 11.396 12H2v5.5A3.5 3.5 0 0 0 5.5 21h7.75V10.75Z" }),
        React.createElement("path", { d: "M14.75 21h3.75a3.5 3.5 0 0 0 3.5-3.5V12h-5.396a2 2 0 0 1-1.854-1.25V21Z" })));
});
